import { render, staticRenderFns } from "./TraxUiCardWithBackground.vue?vue&type=template&id=6f902716"
import script from "./TraxUiCardWithBackground.vue?vue&type=script&lang=js"
export * from "./TraxUiCardWithBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports